import Button from './Button';
import ButtonGroup from './ButtonGroup';

const { SIZE, STYLE } = Button;

export {
    Button as default,
    Button,
    ButtonGroup,
    SIZE,
    STYLE,
};
